import type { NextPage } from 'next';
import { PrivacyDisclaimerComponent, getStaticPropsNicho } from 'ui';

const PrivacyDisclaimer: NextPage = () => {
	return <PrivacyDisclaimerComponent domain="www.altairstudios.es" />;
};

export const getStaticProps = getStaticPropsNicho();
export default PrivacyDisclaimer;
